$(document).ready(function () {    
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        var step = $(e.target).parents('li').index() + 1;
        $('#app-example-form > #step').val(step);
    });
    
    $('a[data-toggle="tab"]').on('click', function(e) {
        var step = $(e.target).parents('li').index() + 1;
        
        if (step == 1){
            $('#next_step').val(step + 1);
        } else {
            $('#next_step').val(step);
        }
        
        if ($(this).parent().hasClass('disabled')) {
            e.preventDefault();
            
            $('#app-example-form').submit();
        }
    });
        
    if ($('.wizard').length != 0 && $('#admin_approval_copy').val() == 1 && $('.alert.alert-danger').length != 0) {
        $('.wizard-inner > .nav li:eq(0) a').tab('show').parents('li');
        
        $('#app-example-form > #step').val('1');
    }
    
    if ($('#app-example-form > #admin_approval').val() == '1') {
        $('#admin_approval_copy').attr('checked', 'checked');
    }
    
    if ($('#app-example-form > #status').val() == '1'){
        $('#status_copy').attr('checked', 'checked');
    }
    
    $('a[data-toggle="tab"]').on('show.bs.tab', function (e) {
        var $target = $(e.target);
        
        if ($target.parent().hasClass('disabled')) {
            return false;
        }
    });
    
    $(document).on('click', '.btn.open-preview', function(e) {
        $('#redirect_preview').val(1);
    });
    
    $(document).on('click', '.finish-step', function(e) {        
        $('#example_id').attr('data-form-state', false);
        
        $('#app-example-form > #status').val($('#status_copy').is(':checked') ? 1 : 0);
        
        if (!$(this).hasClass('finish-temp')) {
            $('#save_publish').val('1')
        } else {
            if ($('input#step').val() == '1') {
                $('input#next_step').val('1');
            }
        }
        
        if ($(this).hasClass('open-preview')) {
            $('#redirect_preview').val(1);
        }
        
        $('.imageDesc').each(function() {
            var index = $(this).parents('li.well').attr('qq-file-id');
            
            var imageDataRAW = $('#app-example-form > input[data-image-index=\'' + index + '\']').val();
            var imageData = $.parseJSON(imageDataRAW);

            imageData.image_desc = $(this).val();

            imageDataRAW = JSON.stringify(imageData);
            $('#app-example-form > input[data-image-index=\'' + index + '\']').val(imageDataRAW);
        });
        
        var previewImage = $('input.is_preview_image:checked').val();
        $('#preview_image').val(previewImage);
        
        $('#app-example-form').submit();
    });
    
    $(document).on('click', '#admin_approval_copy', function(e) { 
        $('#app-example-form > #admin_approval').val($(this).is(':checked') ? 1 : 0);
    });
    
    $(document).on('click', '#status_copy', function(e) { 
        $('#app-example-form > #status').val($(this).is(':checked') ? 1 : 0);
    });
});